import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getCertificatesPage = createAsyncThunk('certificatesPage/getCertificatesPage', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getCertificatesPage();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
